export const FILTERS_BAR_OPEN = "FILTERS_BAR_OPEN";
export const FILTERS_BAR_CLOSE = "FILTERS_BAR_CLOSE";